export const TOAST_TYPES = {
  error: 'error',
  info: 'info',
  remove: 'remove',
  success: 'success',
  warning: 'warning',
};



// WEBPACK FOOTER //
// ./src/js/forms/enums/ToastTypes.js